import { createReducer, on } from '@ngrx/store';

import * as AppActionTypes from './actions';
import { AppState } from '../shared/models';

export const appReducer = createReducer<AppState>(
  {},
  on(AppActionTypes.SetDefaultCropYear, (state, { cropYear }) => ({
    ...state,
    defaultCropYear: cropYear,
  })),
  on(AppActionTypes.SetDefaultSoilType, (state, { soilTypeId }) => ({
    ...state,
    defaultSoilType: soilTypeId,
  })),
  on(AppActionTypes.SetAvailableCropYears, (state, { availableCropYears }) => ({
    ...state,
    availableCropYears,
  })),
  on(AppActionTypes.GetLatestSoilAnalysisSuccess, (state, { soilAnalysisGroups }) => ({
    ...state,
    soilAnalysisByCropFieldId: soilAnalysisGroups,
  })),
  on(AppActionTypes.LoadCropsSuccess, (state, { crops }) => ({ ...state, crops })),
  on(AppActionTypes.LoadCropVarietiesByCropIdsSuccess, (state, { cropVarieties }) => ({
    ...state,
    cropVarieties,
  })),
  on(AppActionTypes.SetReportSort, (state, { reportSort }) => ({
    ...state,
    reportSort,
  })),
  on(AppActionTypes.SetReportManureSubstancesView, (state, { reportManureSubstancesView }) => ({
    ...state,
    reportManureSubstancesView,
  })),
  on(AppActionTypes.LoadCustomerProgressSuccess, (state, { customerProgress }) => ({
    ...state,
    customerProgress,
  })),
);
